/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module VsLogsModule
 */

import { Injector } from '@angular/core';

const $injector = '$injector';

export const TimeFormatterServiceProvider = {
    deps: [$injector],
    provide: '$filter',
    useFactory: (injector: Injector): any => injector.get('$filter'),
};

export const NoValueLogLabelProvider = {
    deps: [$injector],
    provide: 'noValueLogLabel',
    useFactory: (injector: Injector): string => injector.get('noValueLogLabel'),
};
